<template>
  <div :class="$style.container" v-if="projects">
    <div :class="$style.titleSection">
      <div :class="$style.title">RECENT PROJECTS</div>
      <router-link to="/projects/me" class="button" :class="$style.button">
        <span>Go to Projects</span>
        <span class="icon">
          <i class="fas fa-chevron-right"></i>
        </span>
      </router-link>
    </div>

    <div :class="$style.contentSection">
      <p-data-table
        :data="projectList"
        :hoverable="true"
        :noDataText="`No projects found`"
        :class="$style.table"
      >
        <template slot="thead">
          <tr>
            <td :class="$style.projectTitleCell">Project Title</td>
            <td width="20%">Date Created</td>
            <td width="20%">Data Collection Start Date</td>
            <td width="15%">Total Data Collected</td>
          </tr>
        </template>
        <template slot="tbody" slot-scope="{ data }">
          <tr v-for="item in data" :key="item.id">
            <td :class="$style.projectTitleCell">
              <router-link :to="getProjectUrl(item)">
                {{ item.title }}
              </router-link>
            </td>
            <td>{{ formatDate(item.createdAt) }}</td>
            <td>{{ dataCollectionStartDate(item) }}</td>
            <td>{{ item.totalDataCollected }}</td>
          </tr>
        </template>
      </p-data-table>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/utils/date.util';
import { Action, State } from 'vuex-class';
import { ProjectDetailPayload } from '@/store/modules/projects/types/projects.types';
import { useUserEmail } from '@/utils/user.util';
import { getProjectUrlByRole } from '@/utils/project.util';

@Component({ components: {} })
export default class DashboardProjectList extends Vue {
  @Action('projects/getMyProjectsSummary')
  public getMyProjectsSummary!: () => void;

  @State((state) => state.projects.myProjectsSummary)
  public projects!: ProjectDetailPayload[];

  public mounted() {
    this.getMyProjectsSummary();
  }

  get projectList() {
    return this.projects ? this.projects : [];
  }

  public getProjectUrl(item: any) {
    return getProjectUrlByRole(item.id, item.userRoleInProject);
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  public dataCollectionStartDate(project: any): string {
    if (project.dataCollectionStartDate) {
      return this.formatDate(project.dataCollectionStartDate);
    } else {
      return 'N/A';
    }
  }

  public formatDate(s: string) {
    return dayjs(s).format(DATE_FORMAT);
  }
}
</script>
<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px 0;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }

  .contentSection {
    border-radius: 6px;
  }
}
.table {
  table {
    table-layout: fixed;
  }
}
.projectTitleCell {
  width: 45%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
